module.exports = __webpack_public_path__ + "img/tarsius-next-logo-head-pink-52.c7aff169.png";